import { Directive } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Directive({selector: 'diretivaCriptografia'})
export class Criptografia {
  private static encryptSecretKey: string = "480ef354-4eae-4bb1-bd23-11f6aee70f2c";

  public static encryptData(data) {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
    } catch (e) {
      console.log(e);
    }
  }

  public static decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  }
}
